// extracted by mini-css-extract-plugin
export var container = "SectionTitle_container__LAf8F";
export var drawerToggleButton = "SectionTitle_drawerToggleButton__VHT61";
export var title = "SectionTitle_title__QBpaP";